import React, { useContext, useMemo, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { ToastContext } from "../context/ToastContext";

interface SubmitValue {
  reason: string;
  reasonCode?: string;
}

export interface InvoiceDisputeDialogProps {
  open: boolean;
  codes: { id: string; description: string }[];
  onClose: () => void;
  onSubmit: (v: SubmitValue) => void;
  isLoading?: boolean;
}

const InvoiceDisputeDialog = ({ open, codes, onClose, onSubmit, isLoading = false }: InvoiceDisputeDialogProps) => {
  const { showToast } = useContext(ToastContext);
  const [reasonValue, setReasonValue] = useState("");
  const [reasonCode, setReasonCode] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReasonValue(e.target.value);
  };

  const handleConfirm = () => {
    onSubmit({ reason: reasonValue, reasonCode });
    onClose();
    setReasonValue("");
  };

  const handleClose = () => {
    onClose();
    setReasonValue("");
  };

  const codeOptions = useMemo(() => {
    return codes.map((code) => ({
      label: code.description,
      value: code.id,
    }));
  }, [codes]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6" fontSize="18px">
          Dispute Invoice
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: "10px !important" }}>
        <FormControl fullWidth size="small" variant="outlined">
          <InputLabel>Reason Code</InputLabel>
          <Select
            value={reasonCode}
            fullWidth
            size="small"
            sx={{ mb: 1 }}
            label="Reason Code"
            onChange={(e) => setReasonCode(e.target.value)}
          >
            {codeOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value} sx={{ textTransform: "capitalize", width: "80%" }}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          autoFocus
          size="small"
          margin="dense"
          label="Reason for Dispute"
          placeholder="Enter text"
          type="text"
          rows={2}
          multiline
          fullWidth
          variant="outlined"
          value={reasonValue}
          onChange={handleInputChange}
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button size="small" onClick={handleConfirm} variant="contained" color="primary" disabled={isLoading}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDisputeDialog;
